import { LOCAL__grid2d_upsert } from '@/state/grid2d/grid2d/LOCAL__grid2d_upsert';
import { store } from '@/state/store';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { DTO__grid2d_chunk_generation } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk_generation';
import { recreate_chunk_indices_for_grid2d_user_task } from './recreate_chunk_indices_for_grid2d_user_task';

export function try_update_from_generation_on_user_task_grid2d_chunk_without_cells(grid2d_chunk_update: DTO__grid2d_chunk) {
  if (grid2d_chunk_update.entity_type != ENUM__workspace_entity.ENTITY_GENERATION) return; //no need to update user user task

  assert_instanceof(grid2d_chunk_update, DTO__grid2d_chunk_generation);

  let { slice_grid2d, slice_generation } = store.getState();

  let user_task = slice_generation.user_tasks_map.get(grid2d_chunk_update.user_task_id);
  if (!user_task) return; //not loaded yet

  let grid2d_user_task = slice_grid2d.grids2d_map.get(user_task._id);
  if (!grid2d_user_task) return; //not loaded yet

  let grid2d_chunk_user_task = grid2d_user_task.chunk__get_by_id_or_assert(grid2d_chunk_update._id);

  for (let key of Object.keys(grid2d_chunk_update)) {
    if (key == DTO__grid2d_chunk.KEY_CELLS_LIST) continue;
    if (key == DTO__grid2d_chunk.KEY_GRID2D_ID) continue;
    if (key == DTO__grid2d_chunk.KEY_ENTITY_TYPE) continue;
    if (key === DTO__grid2d_chunk.KEY_ARE_CELLS_LOADED_FIRST_TIME) continue;

    (grid2d_chunk_user_task as any)[key] = (grid2d_chunk_update as any)[key];
  }

  grid2d_user_task.chunk__upsert(grid2d_chunk_user_task);

  recreate_chunk_indices_for_grid2d_user_task(grid2d_user_task);

  store.dispatch(LOCAL__grid2d_upsert([grid2d_user_task]));
}
